import store from "@/store";

export function environmentId() {
  return store.state.login.user.environment_id;
}

/**
 * return true/false if element's scroll reached bottom of element's content
 * @param  {Integer} scrollTop height of element's content is vertically scrolled
 * @param  {Integer} clientHeight inner height of the element's visible element content
 * @param  {Integer} scrollHeight height of the element's content with not-visible on the screen due to overflow
 */
export function isScrollBottom(scrollTop, clientHeight, scrollHeight) {
  return scrollTop + clientHeight >= scrollHeight;
}

export function getDeepCopy(data) {
  return JSON.parse(JSON.stringify(data));
}

export function sleeper(ms) {
  return function(x) {
    return new Promise(resolve => setTimeout(() => resolve(x), ms));
  };
}

export function periodicCall(callback, timer) {
  callback();
  return setInterval(callback, timer);
}

export function getFileNameFromResponseHeader(response) {
  return response.headers["content-disposition"]
    .split("filename=")[1]
    .split(";")[0];
}

export function chunkArray(arr, size) {
  const result = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }

  return result;
}
